export default __webpack_public_path__ + "static/LaraiahM-ff51342efc31fe7c35b572d7d66e0e4a.png";